import { render } from "./Tarif.vue?vue&type=template&id=430e2494&scoped=true"
import script from "./Tarif.vue?vue&type=script&lang=js"
export * from "./Tarif.vue?vue&type=script&lang=js"

import "./Tarif.vue?vue&type=style&index=0&id=430e2494&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-430e2494"

export default script